import { Button, ButtonProps, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export interface Props extends ButtonProps {
    isSubmitting?: boolean;
    label?: string;
}

export function SubmitButton({
    isSubmitting,
    label = "Submit",
    disabled,
    ...rest
}: Props) {
    const { t } = useTranslation();

    return (
        <Button
            variant="success"
            {...rest}
            disabled={disabled || isSubmitting}
            type="submit"
        >
            {isSubmitting && (
                <span className="pr-1">
                    <Spinner animation="border" size="sm" />
                </span>
            )}
            {t(label) || t("submit")}
        </Button>
    );
}
